import { ReportListComponent } from './report-list/report-list.component';
export var reportRoutes = [
    {
        path: 'report',
        children: [
            {
                path: 'download',
                component: ReportListComponent
            }
        ],
    },
];
var ReportRoutingModule = (function () {
    function ReportRoutingModule() {
    }
    return ReportRoutingModule;
}());
export { ReportRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/report/report-routing.module.ts.pre-build-optimizer.js